<template>
  <div v-show="isLoaded" class="constructor_scroll">
    <div class="container-block" :class="{container_large: !$store.state.menuDesktopShow}">
      <div class="tittle">
        <div class="breadcrumbs">
          <router-link to="/blog-categories">{{textContent.title}}</router-link>
          <span></span>
          <h1>{{copyItem.title}}</h1>
        </div>
      </div>
      <div class="edit_main">
        <div class="folder radius">
          <div class="column caption">
            <p>Редактирование категории</p>
          </div>
          <div class="column">
            <div class="content">
              <new-input title="Название категории" name="title"></new-input>
              <new-input title="Ссылка" name="url"></new-input>
              <edit-file class="short align-top" use-case="seo" v-if="isLoaded" title="Изображение"
                         name="img"></edit-file>
              <new-input title="Название страницы" name="seo_title"></new-input>
              <new-text-area title="Описание" name="seo_desc"></new-text-area>
              <new-text-area title="Ключевые слова" name="seo_key"></new-text-area>
            </div>
          </div>
        </div>
        <div class="buttons">
          <button class="save" @click="onSubmit">{{textContent.saveButton}}</button>
          <button class="cancel" @click="reset">{{textContent.cancelButton}}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import IconUpload from '@/components/icons/IconUpload'
  import NewTextArea from '@/components/edit-form/new-items/TextArea'
  import NewInput from '@/components/edit-form/new-items/Input'
  import OldInput from '@/components/edit-form/old-items/Input'
  import OldTextArea from '@/components/edit-form/old-items/TextArea'
  import OldEditor from '@/components/edit-form/old-items/Editor'
  import EditDropDown from '@/components/edit-form/DropDown'
  import EditFile from '@/components/edit-form/File'
  import {createNamespacedHelpers} from 'vuex'

  const {mapMutations, mapActions, mapState} = createNamespacedHelpers('editPage')

  export default {
    data: function () {
      return {
        ckeditor: null,
        text: ''
      }
    },
    computed: {
      ...mapState([
        'isLoaded',
        'item',
        'copyItem',
        'textContent'
      ]),
      apiUrls () {
        return this.$store.state.apiUrls
      }
    },
    methods: {
      ...mapActions([
        'init',
        'edit',
        'reset'
      ]),
      ...mapMutations([
        'setFileExtensions'
      ]),
      onSubmit () {
        this.edit({
          title: this.item.title,
          url: this.item.url,
          img: this.item.img,
          seo_title: this.item.seo_title,
          seo_desc: this.item.seo_desc,
          seo_key: this.item.seo_key,
          seo_alt: this.item.seo_alt,
        })
      }
    },
    mounted () {
    },
    created () {
      this.setFileExtensions({img: ['jpg', 'jpeg', 'png', 'gif']})
      this.init({
        textContent: {
          title: 'Категории блога',
          cancelButton: 'Отмена',
          saveButton: 'Сохранить',
          greeting: 'Все изменения успешно сохранены',
          subtitle: 'Редактирование категории блога',
          seo: 'SEO информация',
          options: 'Прочие настройки',
        },
        errors: {
          title: {message: 'Введите название категории', hasError: false},
          url: {message: 'Введите ссылку', hasError: false, isNullable: false},
          seo_title: {message: 'Введите название страницы', hasError: false},
          seo_desc: {message: 'Напишите краткое описание', hasError: false},
          seo_key: {message: 'Напишите ключевые слова', hasError: false},
          img: {message: 'Допустимые расширения: jpg, jpeg, png, gif', isNullable: true, hasError: false}
        },
        itemId: this.$route.params.id,
        apiUrl: this.apiUrls.content
      })
    },
    components: {
      NewTextArea,
      NewInput,
      OldInput,
      OldTextArea,
      OldEditor,
      EditDropDown,
      EditFile,
      IconUpload
    }
  }
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/pages/blog/categories/pages/Edit.vue